import { useModalPromise } from '@cp/shared/modal';
import { useCallback } from 'react';
import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { PRICE_VACANCY_MODAL, VACANCY_SUCCESS_MODAL } from '../lib';

export type ResponseNanny = (catalogItem: CatalogItemViewModel, dialogId: number) => Promise<void>;

export const useResponseModal = (): ResponseNanny => {
  const response = useModalPromise(PRICE_VACANCY_MODAL);
  const success = useModalPromise(VACANCY_SUCCESS_MODAL);

  return useCallback(
    async (catalogItem, dialogId) => {
      await response({ catalogItem, dialogId });
      await success({});
    },
    [response, success],
  );
};
